import { supportedLanguages } from 'utils/localizationUtils';

export const PROP_NAME_ACCESS_TOKEN = "praxmedic-access-token";
export const PROP_NAME_LANGUAGE = "praxmedic-langugage";

// access token
export const getAccessToken = (): string | null => {
  return localStorage.getItem(PROP_NAME_ACCESS_TOKEN);
};

export const setAccessToken = (accessToken: string) => {
  localStorage.setItem(PROP_NAME_ACCESS_TOKEN, accessToken);
};

export const clearAccessToken = () => {
  localStorage.removeItem(PROP_NAME_ACCESS_TOKEN);
};

export const getLanguage = () => {

  const localStorageLang: string | null = localStorage.getItem(PROP_NAME_LANGUAGE);

  if (localStorageLang && supportedLanguages.includes(localStorageLang)) {
    return localStorageLang;
  }

  if (supportedLanguages.includes(window.navigator.language.slice(0, 2))) {
    return window.navigator.language.slice(0, 2);
  }

  return "de";
};

export const setLanguage = (language: string) => {
  if (supportedLanguages.includes(window.navigator.language.slice(0, 2))) {
    localStorage.setItem(PROP_NAME_LANGUAGE, language);
  } else {
    localStorage.setItem(PROP_NAME_LANGUAGE, "de");
  }
};

export const getAuthorizationHeaderValue = (authToken: string): string => {
  const tokenValue = (!!authToken) ? authToken : getAccessToken();
  return `Bearer ${tokenValue}`;
};
